import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ru';

const setLocale = (locale) => {
  moment.locale(locale)
};

const getDaysInMonth = (YYYY, MM) => {
  return moment(`${YYYY}-${MM}`, "YYYY-MM").daysInMonth();
};

const namesOfDays = (locale = 'en', isISO) => {
  const weekDays = [...moment.localeData(locale).weekdaysShort()];
  if(isISO){
    const inMemory = weekDays[0];
    weekDays.splice(0, 1);
    weekDays.push(inMemory);
    return weekDays;
  }
  return weekDays
};

const namesOfMonths = (locale = 'en') => {
  return moment.localeData(locale).months()
};

const configureMonth = (month) => {
  let result = month;
  result = result + 1 >= 10 ? result + 1 : `0${result + 1}`;
  return result;
};

export {setLocale, getDaysInMonth, namesOfDays, namesOfMonths, configureMonth}




// WEBPACK FOOTER //
// ./src/app/components/Calendar/utils.js